export const canCreateShare = (projectKey: string): string =>
    `UI_PublishShareInitConfigure.ss_publishsettings.ss_project_${projectKey}`;

export const canConfigureShare = (projectKey: string): string =>
    `UI_PublishShareConfigure.ss_publishsettings.ss_project_${projectKey}`;

export const canPublish = (projectKey: string): string =>
    `UI_Publish.ss_fragments.ss_project_${projectKey}`;
export const canShare = (projectKey: string): string =>
    `UI_PublishShare.ss_fragments.ss_project_${projectKey}`;

export const canCreateFragment = (projectKey: string): string =>
    `UI_CreateFromSelections.ss_fragments.ss_project_${projectKey}`;

export const canUploadFragment = (projectKey: string): string =>
    `UI_CreateFromFile.ss_fragments.ss_project_${projectKey}`;

export const canEditFragment = (projectKey: string): string =>
    `UI_CreateEdit.ss_fragments.ss_project_${projectKey}`;

export const canCreateCompilation = (projectKey: string): string =>
    `UI_CreateCompilation.ss_fragments.ss_project_${projectKey}`;

export const canDeleteFragment = (projectKey: string): string =>
    `UI_Delete.ss_fragments.ss_project_${projectKey}`;

export const canManageAddons = (projectKey: string): string =>
    `UI_Manage.ss_mediafiles.ss_project_${projectKey}`;

export const isProjectAdmin = (projectKey: string): string =>
    `UI_Manage.ss_project_${projectKey}`;
